import { HEADER, HEADER_TYPE } from '@/constants/header';

export const setHeaderOptions = (headerType) => {
  let opt = {
    withContact: false,
    withHelp: false,
    withTrustedShop: false,
    withPrimeurAlert: false,
    withAdmin: false,
    withAccount: false,
    withCart: false,
    withLeaveStorage: false,
    withReturnToAccount: false,
    withReturnToExpro: false,
    withDeliveryCountry: false
  };
  switch (headerType) {
    case HEADER_TYPE.DEFAULT:
      opt = {
        ...opt,
        withContact: true,
        withHelp: true,
        withTrustedShop: true,
        withPrimeurAlert: true,
        withAdmin: true,
        withAccount: true,
        withCart: true,
        withDeliveryCountry: true
      };
      break;
    case HEADER_TYPE.CHECKOUTCSR:
      opt = {
        ...opt,
        withAdmin: true
      };
      break;
    case HEADER_TYPE.CELLAR:
      opt = {
        ...opt,
        withCart: true,
        withLeaveStorage: true
      };
      break;
    case HEADER_TYPE.PRIMEUR_CHECKOUT:
      opt = {
        ...opt,
        withReturnToExpro: true
      };
      break;
    default:
  }

  return opt;
};

export const setHeaderMobileOptions = (headerType) => {
  let opt = {
    withMenu: false,
    withCart: false,
    withAdmin: false,
    withDeliveryCountry: false
  };

  switch (headerType) {
    case HEADER_TYPE.DEFAULT:
      opt = {
        ...opt,
        withMenu: true,
        withCart: true,
        withDeliveryCountry: true
      };
      break;
    case HEADER_TYPE.CELLAR:
      opt = {
        ...opt,
        withCart: true,
        withLeaveStorage: true
      };
      break;
    default:
  }

  return opt;
};

export const checkHoverMenu = (hovermenu, options) => {
  switch (hovermenu) {
    case HEADER.ADMIN:
      return options.withAdmin;
    case HEADER.ACCOUNT:
      return options.withAccount;
    case HEADER.CART:
      return options.withCart;
  }
};
